import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/shared/ui/tooltip";
import { Toaster } from "@/shared/ui/toaster";
import { Toaster as Sonner } from "@/shared/ui/sonner";
import { queryClient } from "./queryClient";
import ErrorBoundary from "./ErrorBoundary";
import { BuildBadge } from "@/components/BuildBadge";

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        {children}
        <BuildBadge />
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);
